import React from 'react';
import PropTypes from 'prop-types';
import { Callout } from 'components/UI/Callout/Callout';

export const RegistrationFormHeader = (props) => {
  const { errorMessage, complexErrorMessage } = props;

  return (
    <>
      <div className="row">
        <div className="col-md-10 col-lg-8">
          <p className="intro intro-lg">
            Thank you for your interest in Arts Centre Melbourne. Please complete your account
            registration below to book tickets online, manage your account preferences or sign up to
            stay informed of promotions and offers.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6 col-md-8 col-md-offset-1">
          <p className="large form-intro">
            Need help? Contact us on <strong>1300 182 183</strong> between 9am - 4:30pm Monday -
            Friday.
            <br />
            Please note that hours are subject to change on Public Holidays.
          </p>

          {errorMessage && <Callout errorMessage={errorMessage} extendClass="form-global-error" />}

          {complexErrorMessage && (
            <Callout extendClass="form-global-error">
              <p>
                The password supplied does not meet the minimum complexity requirements. Password
                should be <strong>6 or more characters</strong> and contain:
              </p>
              <p>
                - English upper OR lower case letters (A to Z); <strong>and</strong>
              </p>
              <p>- At least one number (0 to 9) or character (such as !, $, #, %)</p>
              <p>
                <strong>But please don't:</strong>
              </p>
              <p>- Use your account login details or name in the password</p>
            </Callout>
          )}

          <p>All fields required unless otherwise marked.</p>
        </div>
      </div>
    </>
  );
};

RegistrationFormHeader.propTypes = {
  errorMessage: PropTypes.string,
  complexErrorMessage: PropTypes.string,
};
